// extracted by mini-css-extract-plugin
export var wordContainer = "_mg-0";